// import React, { useEffect, useState } from "react";
// import {
//   Box,
//   Card,
//   Typography,
//   LinearProgress,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   Rating,
//   CircularProgress,
// } from "@mui/material";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";

// import { ThunkDispatch } from "@reduxjs/toolkit";
// import { useDispatch, useSelector } from "react-redux";

// import {
//   ToastVariant,
//   useCustomToast,
// } from "../../components/Methods/SnackBar";

// import { RootState } from "../../store/Store";
// import {
//   FetchDataSuccessAction,
//   FetchDataFailureAction,
//   fetchData,
//   postData,
//   DataPayload,
// } from "../../store/actions";

// import {
//   editEmployeeSkillResponse,
//   viewEmployeeSkillResponse,
// } from "../../Service/Apis";

// import { setInPageLoading } from "../../store/LoadingSlice";
// import { EmployeeSkillSetType } from "./Types/SkillTypes";
// import NothingToDisplayComponent from "../../components/Data/NothingToShowComponent";
// import Loading from "../../components/Loading/Loading";
// import Navbar from "../../components/Page Component/Navbar";

// const label = ["Awareness", "Novice", "Competant", "Professional", "Expert"];

// const ratingLabel = [
//   { label: "Awareness", color: "#FF5C5C" }, // Red
//   { label: "Novice", color: "#5C8CFF" }, // Blue
//   { label: "Competent", color: "#5CFF6E" }, // Green
//   { label: "Professional", color: "#FF9F5C" }, // Orange/Pink
//   { label: "Expert", color: "#B85CFF" }, // Violet
// ];

// const EmployeeSkillSet = () => {
//   // State Hooks
//   const [data, setData] = useState<EmployeeSkillSetType[]>([]);
//   const [selectedSkill, setSelectedSkill] =
//     useState<EmployeeSkillSetType | null>(null);
//   const [openDialog, setOpenDialog] = useState(false);
//   const [count, setCount] = useState<number>(0);

//   // Toast Hook
//   const showToast = useCustomToast();

//   // Redux Hooks
//   const dispatch = useDispatch();
//   const dispatch2: ThunkDispatch<
//     RootState,
//     null,
//     FetchDataSuccessAction | FetchDataFailureAction
//   > = useDispatch();

//   // Selector for Loading State
//   const isLoading = useSelector((state: any) => state.loading.inPageLoading);

//   // Show Toast Helper Function
//   const handleShowToast = (
//     message: string,
//     variant: ToastVariant,
//     isCloseable: boolean
//   ) => {
//     showToast(message, variant, isCloseable);
//   };

//   const getLabelAndColor = (linearProgressBarValue: any) => {
//     let cumulativePercentage = 0;
//     for (const { label, color } of ratingLabel) {
//       const labelRange = 20; // Each label gets 20% range
//       if (linearProgressBarValue <= cumulativePercentage + labelRange) {
//         return { label, color };
//       }
//       cumulativePercentage += labelRange;
//     }
//   };

//   // Calculate Progress Function
//   const calculateProgress = (questions: any) => {
//     const attemptedCount = questions.filter(
//       (que: any) => que.employee_skill_response !== null
//     ).length;
//     return (attemptedCount / questions.length) * 100;
//   };

//   // Handle Rating Change Function
//   const handleRatingChange = (value: string, selectedQuestionIndex: number) => {
//     if (selectedSkill && selectedQuestionIndex !== null) {
//       const updatedQuestions = [...selectedSkill.questions];
//       updatedQuestions[selectedQuestionIndex].employee_skill_response =
//         value === undefined ? null : value;
//       setSelectedSkill({ ...selectedSkill, questions: updatedQuestions });
//     }
//   };

//   // Open Dialog Function
//   const handleDialogOpen = (skill: EmployeeSkillSetType) => {
//     setSelectedSkill(skill);
//     setOpenDialog(true);
//   };

//   // Close Dialog Function
//   const handleDialogClose = () => {
//     setOpenDialog(false);
//   };

//   // Save Function
//   const handleSave = async () => {
//     const { skill_id }: any = selectedSkill;
//     const data2 = {
//       responses: selectedSkill?.questions,
//     };

//     try {
//       const response = await dispatch2(
//         postData(
//           `${editEmployeeSkillResponse}${selectedSkill?.skill_id}/`,
//           data2
//         )
//       );
//       handleShowToast("Skill Response Updated!", "success", true);
//       setSelectedSkill(null);
//       setCount(count + 1);
//       handleDialogClose();
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   // Fetch Employee Skill Response Effect
//   useEffect(() => {
//     const fetchEmployeeSkillResponse = async () => {
//       try {
//         dispatch(setInPageLoading(true));
//         const response = await dispatch2(
//           fetchData(`${viewEmployeeSkillResponse}`)
//         );
//         setData(response as EmployeeSkillSetType[]);
//       } catch (error) {
//         console.log(error);
//       } finally {
//         dispatch(setInPageLoading(false));
//       }
//     };
//     fetchEmployeeSkillResponse();
//   }, [count]);

//   // Loading Spinner Component
//   if (isLoading) {
//     return (
//       <>

//         <Loading isLoading={isLoading as boolean} />
//       </>
//     );
//   }

//   // Main Component
//   return (
//     <>
//     <Box id="main-component">
//       {data.length === 0 ? (
//         <>
//           <Box
//             sx={{
//               mt: 12,
//               left: "50%",
//               display: "flex",
//               justifyContent: "center",
//             }}
//           >
//             <NothingToDisplayComponent />
//           </Box>
//         </>
//       ) : (
//         <>
//           <Box
//             sx={{
//               width: "98%",
//               display: "flex",
//               mx: 2,
//               mt: 2,
//             }}
//           >
//             <Box sx={{ width: "20%" }}></Box>
//             <Box sx={{ width: "70%", display: "flex" }}>
//               <Box
//                 sx={{
//                   width: "90%",
//                   mr: 2.7,
//                   ml: 1,
//                   display: "flex",
//                   justifyContent: "center",
//                   textAlign: "center",
//                 }}
//               >
//                 {ratingLabel.map((data, index) => {
//                   return (
//                     <Box
//                       sx={{
//                         display: "flex",
//                         justifyContent: "center",
//                         alignItems: "center",
//                         width: "20%",
//                         // mr: 1.7,
//                         // mt: -0.8,
//                       }}
//                     >
//                       <Typography
//                         key={index}
//                         sx={{ mr: 0.3 }}
//                         fontSize={13}
//                         fontWeight={"bold"}
//                       >
//                         {data.label}
//                       </Typography>
//                     </Box>
//                   );
//                 })}
//               </Box>
//               <Box sx={{ width: "10%" }}></Box>
//             </Box>
//             <Box sx={{ width: "10%" }}></Box>
//           </Box>
//           {data.map((emp, index) => {
//             return (
//               // Skill Card
//               <Card
//                 key={index}
//                 id={`skill-card-${index}`}
//                 sx={{ m: 2, p: 2 }}
//                 elevation={4}
//               >
//                 <Box
//                   id={`skill-card-content-${index}`}
//                   sx={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                   }}
//                 >
//                   {/* Skill Name */}
//                   <Box id={`skill-name-${index}`} sx={{ width: "20%" }}>
//                     <Typography
//                       variant="h6"
//                       color="primary"
//                       fontWeight={"bold"}
//                     >
//                       {emp.skill_name}
//                     </Typography>
//                   </Box>
//                   {/* Progress Bar */}
//                   <Box
//                     id={`progress-bar-${index}`}
//                     sx={{
//                       width: "70%",
//                       mx: 2,
//                       display: "flex",
//                       alignItems: "center",
//                     }}
//                   >
//                     <Box sx={{ width: "100%", position: "relative" }}>
//                       <LinearProgress
//                         variant="determinate"
//                         value={parseFloat(emp.percentage)}
//                         sx={{
//                           flexGrow: 1,
//                           mr: 2,
//                           // backgroundColor: "#E0E0E0",
//                           // "& .MuiLinearProgress-barColorPrimary": {
//                           //   backgroundColor: color,
//                           // },
//                         }}
//                       />
//                       <div
//                         className="skill-info-color"
//                         style={{
//                           position: "absolute",
//                           top: "50%",
//                           transform: `translate(-50%, -50%)`,
//                           left: `${
//                             parseFloat(emp.percentage) > 50
//                               ? parseFloat(emp.percentage) - 1.5
//                               : parseFloat(emp.percentage)
//                           }%`,
//                           width: "12px",
//                           height: "12px",
//                           borderRadius: "50%",
//                         }}
//                       />
//                     </Box>
//                     <Typography
//                       sx={{ width: "10%" }}
//                       variant="h6"
//                       fontWeight={"bold"}
//                       fontSize={14}
//                     >
//                       {parseFloat(emp.percentage).toFixed(2)}%
//                     </Typography>
//                   </Box>
//                   {/* Completion Info */}
//                   <Box
//                     id={`completion-info-${index}`}
//                     sx={{
//                       display: "flex",
//                       alignItems: "center",
//                       width: "10%",
//                       justifyContent: "right",
//                     }}
//                   >
//                     <Typography
//                       variant="h6"
//                       color={
//                         emp.questions.filter(
//                           (que) => que.employee_skill_response !== null
//                         ).length === emp.questions.length
//                           ? "success"
//                           : "error"
//                       }
//                     >
//                       {
//                         emp.questions.filter(
//                           (que) => que.employee_skill_response !== null
//                         ).length
//                       }
//                       /{emp.questions.length}
//                     </Typography>
//                     {/* Chevron Icon */}
//                     <ChevronRightIcon
//                       id={`chevron-icon-${index}`}
//                       fontSize="medium"
//                       sx={{ cursor: "pointer" }}
//                       onClick={() => handleDialogOpen(emp)}
//                     />
//                   </Box>
//                 </Box>
//                 {/* Fullscreen Dialog */}
//                 <Dialog
//                   id={`fullscreen-dialog-${index}`}
//                   open={openDialog}
//                   onClose={handleDialogClose}
//                   fullScreen
//                   sx={{ overflow: "auto" }}
//                 >
//                   {selectedSkill && (
//                     <>
//                       {/* Dialog Title */}
//                       <DialogTitle
//                         id={`dialog-title-${index}`}
//                         sx={{
//                           display: "flex",
//                           justifyContent: "center",
//                           m: 2,
//                           p: 2,
//                         }}
//                       >
//                         <Typography
//                           id={`dialog-title-typography-${index}`}
//                           fontWeight={"bold"}
//                           variant="h4"
//                           color={"#007300"}
//                         >
//                           {`Questions for ${selectedSkill.skill_name}`}
//                         </Typography>
//                       </DialogTitle>
//                       {/* Dialog Content */}
//                       <DialogContent
//                         id={`dialog-content-${index}`}
//                         sx={{ ml: 5, mr: 5, mt: 2, p: 2 }}
//                       >
//                         {selectedSkill.questions.map(
//                           (question, questionIndex) => (
//                             // Question Card
//                             <Card
//                               key={question.skill_question_id}
//                               id={`question-card-${index}-${questionIndex}`}
//                               sx={{
//                                 mb: 2,
//                                 p: 2,
//                                 boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)", // Add boxShadow here
//                                 border: "1px solid #ccc",
//                               }}
//                               elevation={5}
//                             >
//                               {/* Question Text */}
//                               <Box
//                                 id={`question-text-${index}-${questionIndex}`}
//                               >
//                                 <Typography fontWeight={"bold"} variant="h6">
//                                   {questionIndex + 1 + ") "}
//                                   {question.question}
//                                 </Typography>
//                               </Box>
//                               {/* Rating */}
//                               <Box
//                                 id={`rating-box-${index}-${questionIndex}`}
//                                 sx={{
//                                   display: "flex",
//                                   alignItems: "center",
//                                   m: 1.5,
//                                   p: 1,
//                                 }}
//                               >
//                                 <Rating
//                                   name={`rating-${index}-${questionIndex}`}
//                                   value={parseInt(
//                                     question.employee_skill_response || "0"
//                                   )}
//                                   size="large"
//                                   onChange={(event, value) => {
//                                     handleRatingChange(
//                                       value?.toString() as string,
//                                       questionIndex
//                                     );
//                                   }}
//                                   className="rating-color"
//                                 />
//                               </Box>
//                             </Card>
//                           )
//                         )}
//                       </DialogContent>
//                       {/* Dialog Actions */}
//                       <DialogActions
//                         id={`dialog-actions-${index}`}
//                         sx={{ m: 2, p: 2 }}
//                       >
//                         <Button
//                           id={`save-button-${index}`}
//                           variant="contained"
//                           onClick={() => {
//                             handleSave();
//                           }}
//                         >
//                           Save
//                         </Button>
//                         <Button
//                           id={`close-button-${index}`}
//                           variant="outlined"
//                           onClick={handleDialogClose}
//                         >
//                           Close
//                         </Button>
//                       </DialogActions>
//                     </>
//                   )}
//                 </Dialog>
//               </Card>
//             );
//           })}
//         </>
//       )}
//     </Box>

//     </>

//   );
// };

// export default EmployeeSkillSet;

//===============================================================

import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  Typography,
  Chip,
  CircularProgress,
  Divider,
  LinearProgress,
  Button,
  Rating,
  TextField,
} from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import SaveIcon from "@mui/icons-material/Save";
import EditIcon from "@mui/icons-material/Edit";

import { ThunkDispatch } from "@reduxjs/toolkit";
import { useDispatch, useSelector } from "react-redux";

import {
  ToastVariant,
  useCustomToast,
} from "../../components/Methods/SnackBar";

import { RootState } from "../../store/Store";
import {
  FetchDataSuccessAction,
  FetchDataFailureAction,
  fetchData,
  postData,
} from "../../store/actions";

import {
  editEmployeeSkillResponse,
  viewEmployeeSkillResponse,
  designationSkillProfile,
  employeeSectionPercentage,
  skillRemark,
} from "../../Service/Apis";

import { setInPageLoading } from "../../store/LoadingSlice";
import { EmployeeSkillSetType } from "./Types/SkillTypes";
import NothingToDisplayComponent from "../../components/Data/NothingToShowComponent";
import Loading from "../../components/Loading/Loading";
import Navbar from "../../components/Page Component/Navbar";
import Footer from "../../components/Page Component/Footer";

// ── Types ─────────────────────────────────────────────────────────────────

interface SectionQuestion {
  skill_question_id: string;
  question: string;
  employee_skill_response: string | null;
  manager_skill_response?: string | null;
}

interface SectionSkill {
  skill_id: string;
  skill_name: string;
  percentage: string;
  questions: SectionQuestion[];
}

interface ProfileSection {
  section_id: string;
  section_name: string;
  weightage: number;
  skills: SectionSkill[];
}

interface SectionScore {
  section_id: string;
  section_name: string;
  weightage: number;
  employee_section_score: number;
  employee_section_contribution: number;
  manager_section_score: number | null;
  manager_section_contribution: number;
  manager_rated: boolean;
}

interface PercentageData {
  overall_employee_percentage: number;
  overall_manager_percentage: number;
  sections: SectionScore[];
}

// ── Component ──────────────────────────────────────────────────────────────

const ratingLabel = [
  { label: "Awareness", color: "#FF5C5C" }, // Red
  { label: "Novice", color: "#5C8CFF" }, // Blue
  { label: "Competent", color: "#5CFF6E" }, // Green
  { label: "Professional", color: "#FF9F5C" }, // Orange/Pink
  { label: "Expert", color: "#B85CFF" }, // Violet
];

const EmployeeSkillSet = () => {
  const [sections, setSections] = useState<ProfileSection[]>([]);
  const [percentages, setPercentages] = useState<PercentageData | null>(null);
  const [remark, setRemark] = useState<string>("");
  const [savedRemark, setSavedRemark] = useState<string>("");
  const [remarkSaving, setRemarkSaving] = useState(false);
  const [isRemarkEditing, setIsRemarkEditing] = useState(false);

  const [selectedSkill, setSelectedSkill] = useState<SectionSkill | null>(null);
  const [expandedSkillId, setExpandedSkillId] = useState<string | null>(null);
  const [expandedSectionId, setExpandedSectionId] = useState<string | null>(null);

  const showToast = useCustomToast();
  const dispatch = useDispatch();
  const dispatch2: ThunkDispatch<RootState, null, FetchDataSuccessAction | FetchDataFailureAction> =
    useDispatch();
  const isLoading = useSelector((state: any) => state.loading.inPageLoading);

  const toast = (msg: string, variant: ToastVariant) => showToast(msg, variant, true);

  // ── Fetch all data on mount ───────────────────────────────────────────

  const loadAll = async () => {
    dispatch(setInPageLoading(true));
    try {
      const designationId = localStorage.getItem("designation_id");

      const [profileRes, responsesRes, percentagesRes, remarkRes]: any[] = await Promise.all([
        designationId
          ? dispatch2(fetchData(`${designationSkillProfile}?designation_id=${designationId}`))
          : Promise.resolve(null),
        dispatch2(fetchData(viewEmployeeSkillResponse)),
        dispatch2(fetchData(employeeSectionPercentage)),
        dispatch2(fetchData(skillRemark)),
      ]);

      // Build response lookup: skill_id → { questions by id }
      const responseMap: Record<string, Record<string, SectionQuestion>> = {};
      if (Array.isArray(responsesRes)) {
        (responsesRes as EmployeeSkillSetType[]).forEach((skill) => {
          responseMap[skill.skill_id] = {};
          skill.questions.forEach((q: any) => {
            responseMap[skill.skill_id][q.skill_question_id] = q;
          });
        });
      }

      // Merge profile + responses
      if (profileRes && profileRes.sections) {
        const merged: ProfileSection[] = profileRes.sections.map((sec: any) => ({
          ...sec,
          skills: sec.skills.map((skill: any) => {
            const skillResponses = responseMap[skill.skill_id] || {};
            const responseSkill = (responsesRes as EmployeeSkillSetType[])?.find(
              (r) => r.skill_id === skill.skill_id
            );
            return {
              ...skill,
              percentage: responseSkill?.percentage || "0",
              questions: skill.questions.map((q: any) => ({
                ...q,
                employee_skill_response:
                  skillResponses[q.skill_question_id]?.employee_skill_response ?? null,
                manager_skill_response:
                  (skillResponses[q.skill_question_id] as any)?.manager_skill_response ?? null,
              })),
            };
          }),
        }));
        setSections(merged);
      }

      if (percentagesRes) setPercentages(percentagesRes as PercentageData);
      const fetchedRemark = remarkRes?.remark ?? "";
      setRemark(fetchedRemark);
      setSavedRemark(fetchedRemark);

    } catch (err) {
      toast("Failed to load skill data.", "error");
    } finally {
      dispatch(setInPageLoading(false));
    }
  };

  useEffect(() => { loadAll(); }, []);

  // ── Rating change (updates local state only) ──────────────────────────

  const handleRatingChange = (value: string, questionIndex: number) => {
    if (!selectedSkill) return;
    const updated = [...selectedSkill.questions];
    updated[questionIndex] = {
      ...updated[questionIndex],
      employee_skill_response: value ?? null,
    };
    setSelectedSkill({ ...selectedSkill, questions: updated });
  };

  // ── Save skill responses ──────────────────────────────────────────────

  const handleSave = async () => {
    if (!selectedSkill) return;
    const savedSkillId = selectedSkill.skill_id;
    try {
      await dispatch2(
        postData(`${editEmployeeSkillResponse}${savedSkillId}/`, {
          responses: selectedSkill.questions,
        })
      );
      toast("Skill response updated!", "success");
      setSelectedSkill(null);
      setExpandedSkillId(null);
      loadAll();
      setTimeout(() => {
        const el = document.getElementById(`skill-card-${savedSkillId}`);
        if (el) {
          const y = el.getBoundingClientRect().top + window.scrollY - 80;
          window.scrollTo({ top: y, behavior: "smooth" });
        }
      }, 0);
    } catch {
      toast("Failed to save responses.", "error");
    }
  };

  // ── Save remark ───────────────────────────────────────────────────────

  const handleSaveRemark = async () => {
    setRemarkSaving(true);
    try {
      await dispatch2(postData(skillRemark, { remark }));
      setSavedRemark(remark);
      toast("Remarks saved successfully.", "success");
      setIsRemarkEditing(false);
    } catch {
      toast("Failed to save remarks.", "error");
    } finally {
      setRemarkSaving(false);
    }
  };

  const isRemarkDirty = remark !== savedRemark;

  // ── Toggle section expand ─────────────────────────────────────────────

  const toggleSection = (sectionId: string) => {
    setExpandedSectionId((prev) => {
      setExpandedSkillId(null);
      setSelectedSkill(null);
      return prev === sectionId ? null : sectionId;
    });
  };

  // ── Toggle inline expand ──────────────────────────────────────────────

  const toggleExpand = (skill: SectionSkill) => {
    if (expandedSkillId === skill.skill_id) {
      setExpandedSkillId(null);
      setSelectedSkill(null);
    } else {
      setExpandedSkillId(skill.skill_id);
      setSelectedSkill(skill);
    }
  };

  // ── Loading ───────────────────────────────────────────────────────────

  if (isLoading) return <Loading isLoading={isLoading} />;

  const hasNoSections = sections.length === 0;
  const overallEmp = percentages?.overall_employee_percentage ?? 0;
  const overallMgr = percentages?.overall_manager_percentage ?? 0;

  // ── Render ────────────────────────────────────────────────────────────

  return (
    <>
      <Box id="main-component" sx={{ mt: 10, mb: 10 }}>
        {hasNoSections ? (
          <Box sx={{ mt: 12, display: "flex", justifyContent: "center" }}>
            <NothingToDisplayComponent />
          </Box>
        ) : (
          <>
            {/* ── Overall percentage summary ── */}
            <Box sx={{ display: "flex", justifyContent: "center", gap: 2, mb: 3, flexWrap: "wrap" }}>
              <Chip
                icon={overallEmp >= 60 ? <CheckCircleIcon /> : <WarningAmberIcon />}
                label={`Your Overall Score: ${overallEmp.toFixed(1)}%`}
                color={overallEmp >= 60 ? "success" : "warning"}
                variant="outlined"
                sx={{ fontSize: 15, px: 1, py: 2.5 }}
              />
              {overallMgr > 0 && (
                <Chip
                  icon={<CheckCircleIcon />}
                  label={`Manager Score: ${overallMgr.toFixed(1)}%`}
                  color="primary"
                  variant="outlined"
                  sx={{ fontSize: 15, px: 1, py: 2.5 }}
                />
              )}
            </Box>

            {/* ── Column headers ── */}
            <Box sx={{ width: "98%", display: "flex", mx: 2, mt: 1, mb: 1 }}>
              <Box sx={{ width: "20%" }} />
              <Box sx={{ width: "70%", display: "flex" }}>
                <Box sx={{ width: "90%", mr: 2.7, ml: 1, display: "flex", justifyContent: "center" }}>
                  {ratingLabel.map((rl, i) => (
                    <Box key={i} sx={{ display: "flex", justifyContent: "center", width: "20%" }}>
                      <Typography fontSize={15} fontWeight="bold">{rl.label}</Typography>
                    </Box>
                  ))}
                </Box>
                <Box sx={{ width: "10%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <Typography fontSize={15} fontWeight="bold">Avg score</Typography>
                </Box>
              </Box>
              <Box sx={{ width: "10%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <Typography fontSize={15} fontWeight="bold">Questions</Typography>
              </Box>
            </Box>

            {/* ── Sections ── */}
            {sections.map((section) => {
              const sectionScore = percentages?.sections.find(
                (s) => s.section_id === section.section_id
              );

              return (
                <Box key={section.section_id} sx={{ mb: 3 }}>
                  {/* Section header — clickable to expand/collapse */}
                  <Box
                    onClick={() => toggleSection(section.section_id)}
                    sx={{
                      mx: 2,
                      px: 3,
                      py: 1.5,
                      backgroundColor: "primary.main",
                      borderRadius: 1,
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      flexWrap: "wrap",
                      gap: 1,
                      cursor: "pointer",
                      userSelect: "none",
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <ChevronRightIcon
                        sx={{
                          color: "white",
                          transform: expandedSectionId === section.section_id ? "rotate(90deg)" : "none",
                          transition: "transform 0.2s",
                        }}
                      />
                      <Typography variant="h6" fontWeight="bold" color="white">
                        {section.section_name}
                        <Typography component="span" variant="body2" color="white" sx={{ ml: 1, opacity: 0.85 }}>
                          (Weightage: {section.weightage}%)
                        </Typography>
                      </Typography>
                    </Box>

                    {sectionScore && (
                      <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                        <Chip
                          size="small"
                          label={`Your Score: ${sectionScore.employee_section_score.toFixed(1)}% → Contribution: ${sectionScore.employee_section_contribution.toFixed(1)}%`}
                          sx={{ backgroundColor: "white", fontWeight: "bold" }}
                        />
                        {sectionScore.manager_rated && sectionScore.manager_section_score != null && (
                          <Chip
                            size="small"
                            label={`Manager: ${sectionScore.manager_section_score.toFixed(1)}% → ${sectionScore.manager_section_contribution.toFixed(1)}%`}
                            sx={{ backgroundColor: "white", fontWeight: "bold" }}
                          />
                        )}
                      </Box>
                    )}
                  </Box>

                  {/* Skills inside section — only when section is expanded */}
                  {expandedSectionId === section.section_id && section.skills.map((skill, skillIndex) => {
                    const totalQuestions = skill.questions.length;
                    const totalPossible = totalQuestions * 5;
                    const managerStars = skill.questions.reduce((sum, q) => {
                      const v = parseInt((q as any).manager_skill_response || "0", 10);
                      return sum + (isNaN(v) ? 0 : v);
                    }, 0);
                    const managerRatedCount = skill.questions.filter(
                      (q: any) => q.manager_skill_response != null && q.manager_skill_response !== "0"
                    ).length;
                    const isManagerComplete = managerRatedCount === totalQuestions;
                    const managerPercentage = totalPossible > 0 ? (managerStars / totalPossible) * 100 : 0;

                    return (
                      <Box key={skill.skill_id} sx={{ pl: 4 }}>
                        <Card id={`skill-card-${skill.skill_id}`} sx={{ m: 2, p: 2 }} elevation={4}>
                          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                            {/* Skill Name */}
                            <Box sx={{ width: "20%", cursor: "pointer" }} onClick={() => toggleExpand(skill)}>
                              <Typography variant="h6" color="primary" fontWeight="bold">
                                {skill.skill_name}
                              </Typography>
                            </Box>

                            {/* Progress bars */}
                            <Box sx={{ width: "70%", mx: 2, display: "flex", flexDirection: "column", gap: 0.5 }}>
                              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                <Typography variant="caption" fontWeight="bold" sx={{ width: 70, textAlign: "right" }} fontSize={15}>Employee</Typography>
                                <Box sx={{ width: "100%", position: "relative" }}>
                                  <LinearProgress variant="determinate" value={parseFloat(skill.percentage)} sx={{ flexGrow: 1, mr: 2 }} />
                                  <div className="skill-info-color" style={{ position: "absolute", top: "50%", transform: "translate(-50%,-50%)", left: `${parseFloat(skill.percentage) > 50 ? parseFloat(skill.percentage) - 1.5 : parseFloat(skill.percentage)}%`, width: 12, height: 12, borderRadius: "50%" }} />
                                </Box>
                                <Typography variant="body2" fontWeight="bold">
                                  {((parseFloat(skill.percentage) / 100) * 5).toFixed(1)}/5
                                </Typography>
                              </Box>
                              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                <Typography variant="caption" fontWeight="bold" sx={{ width: 70, textAlign: "right" }} fontSize={15}>Manager</Typography>
                                <Box sx={{ width: "100%", position: "relative" }}>
                                  <LinearProgress
                                    variant="determinate"
                                    value={managerPercentage}
                                    sx={{
                                      flexGrow: 1, mr: 2,
                                      ...(!isManagerComplete ? { backgroundColor: "#ffebee", "& .MuiLinearProgress-bar": { backgroundColor: "#d32f2f" } } : {}),
                                    }}
                                  />
                                  <div className="skill-info-color" style={{ position: "absolute", top: "50%", transform: "translate(-50%,-50%)", left: `${managerPercentage > 50 ? managerPercentage - 1.5 : managerPercentage}%`, width: 12, height: 12, borderRadius: "50%", ...(!isManagerComplete ? { backgroundColor: "#d32f2f" } : {}) }} />
                                </Box>
                                <Typography variant="body2" fontWeight="bold">
                                  {((managerPercentage / 100) * 5).toFixed(1)}/5
                                </Typography>
                              </Box>
                            </Box>

                            {/* Completion count + chevron */}
                            <Box sx={{ display: "flex", alignItems: "center", width: "10%", justifyContent: "right" }}>
                              <Typography
                                variant="h6"
                                color={skill.questions.filter((q) => q.employee_skill_response !== null).length === totalQuestions ? "success" : "error"}
                              >
                                {skill.questions.filter((q) => q.employee_skill_response !== null).length}/{totalQuestions}
                              </Typography>
                              <ChevronRightIcon
                                fontSize="medium"
                                sx={{ cursor: "pointer", transform: expandedSkillId === skill.skill_id ? "rotate(90deg)" : "none", transition: "transform 0.2s" }}
                                onClick={() => toggleExpand(skill)}
                              />
                            </Box>
                          </Box>

                          {/* Inline question expand */}
                          {expandedSkillId === skill.skill_id && selectedSkill && (
                            <Box sx={{ mt: 2, p: 1 }}>
                              {selectedSkill.questions.map((question, qIndex) => (
                                <Card
                                  key={question.skill_question_id}
                                  sx={{ mb: 2, p: 2, boxShadow: "0px 0px 10px rgba(0,0,0,0.1)", border: "1px solid #ccc" }}
                                  elevation={5}
                                >
                                  <Box sx={{ display: "grid", gridTemplateColumns: "1fr 160px 160px", alignItems: "center", columnGap: 2, m: 1.5, p: 1 }}>
                                    <Box>
                                      <Typography fontWeight="bold" variant="h6" sx={{ textAlign: "justify", wordBreak: "break-word" }}>
                                        {qIndex + 1}){" "}{question.question}
                                      </Typography>
                                    </Box>
                                    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                      <Typography align="center" variant="caption" fontWeight="bold">Employee</Typography>
                                      <Rating
                                        value={parseInt(question.employee_skill_response || "0")}
                                        size="large"
                                        onChange={(_, value) => handleRatingChange(value?.toString() ?? "", qIndex)}
                                        className="rating-color"
                                      />
                                    </Box>
                                    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                      <Typography align="center" variant="caption" fontWeight="bold">Manager</Typography>
                                      <Rating
                                        value={parseInt((question as any).manager_skill_response || "0")}
                                        readOnly
                                        size="large"
                                        className="rating-color"
                                      />
                                    </Box>
                                  </Box>
                                </Card>
                              ))}
                              <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                                <Button variant="contained" onClick={handleSave}>Save</Button>
                              </Box>
                            </Box>
                          )}
                        </Card>
                      </Box>
                    );
                  })}
                </Box>
              );
            })}

            {/* ── Additional Skills / Remarks ── */}
            <Box sx={{ mx: 4, mt: 4 }}>
              <Divider sx={{ mb: 3 }} />
              <Typography variant="h6" fontWeight="bold" mb={1}>
                Additional Skills / Remarks
              </Typography>
              <Typography variant="body2" color="text.secondary" mb={2}>
                Mention any skills you have that are not listed in the sections above.
              </Typography>
              <TextField
                fullWidth
                multiline
                minRows={4}
                maxRows={10}
                variant="outlined"
                placeholder="e.g. I am proficient in Docker, Kubernetes, and have experience with AWS deployments..."
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
                disabled={!isRemarkEditing}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderColor: isRemarkEditing && isRemarkDirty ? "warning.main" : undefined,
                  },
                }}
              />
              <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 1, mt: 1 }}>
                {isRemarkEditing ? (
                  <>
                    {isRemarkDirty && (
                      <Typography variant="caption" color="warning.main" fontStyle="italic">
                        Unsaved changes
                      </Typography>
                    )}
                    <Button
                      variant="outlined"
                      onClick={() => {
                        setRemark(savedRemark);
                        setIsRemarkEditing(false);
                      }}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="contained"
                      onClick={handleSaveRemark}
                      disabled={remarkSaving || !isRemarkDirty}
                      startIcon={remarkSaving ? <CircularProgress size={16} /> : <SaveIcon />}
                    >
                      Save Remarks
                    </Button>
                  </>
                ) : (
                  <>
                    {savedRemark !== "" && (
                      <Chip
                        icon={<CheckCircleIcon />}
                        label="Saved"
                        color="success"
                        size="small"
                        variant="outlined"
                      />
                    )}
                    <Button
                      variant="outlined"
                      startIcon={<EditIcon />}
                      onClick={() => setIsRemarkEditing(true)}
                    >
                      Edit
                    </Button>
                  </>
                )}
              </Box>
            </Box>
          </>
        )}
      </Box>
    </>
  );
};

export default EmployeeSkillSet;